import { Button, ButtonRow } from '@ksyos/design-system';
import { FundingType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import type { Financing } from './financing';

type FinancingProcessesFooterButtonsProps = {
    disableProcessing: boolean;
    disableReporting: boolean;
    isReprocessing: boolean;
    items: Financing[];
    onDownloadReport: () => void;
    onProcessFunding: (fundingType?: FundingType) => void;
    onStopReprocessing: () => void;
};

export function FinancingProcessesFooterButtons(props: FinancingProcessesFooterButtonsProps) {
    const language = getSelectedLanguage();

    return (
        <ButtonRow>
            <Button
                color="secondary"
                isDisabled={props.disableProcessing}
                key={1}
                onClick={() => props.onProcessFunding()}
                variant={'outline'}
            >
                {language.finance.reprocessFinancing}
            </Button>
            <Button
                color="secondary"
                isDisabled={props.disableProcessing}
                key={3}
                onClick={() => props.onProcessFunding(FundingType.freeOfCharge)}
                variant={'outline'}
            >
                {language.finance.freeOfCharge}
            </Button>
            <Button
                color="secondary"
                isDisabled={props.disableProcessing}
                key={4}
                onClick={() => props.onProcessFunding(FundingType.fundingAccordingToSettings)}
                variant={'outline'}
            >
                {language.finance.fundingAccordingToSettings}
            </Button>
            <Button
                color="secondary"
                isDisabled={!props.isReprocessing}
                key={5}
                onClick={() => props.onStopReprocessing()}
                variant={'outline'}
            >
                {language.common.cancel}
            </Button>
            <Button
                color="secondary"
                isDisabled={props.disableReporting}
                key={6}
                onClick={() => props.onDownloadReport()}
                variant={'outline'}
            >
                Rapport
            </Button>
        </ButtonRow>
    );
}
